import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import type Store from '@ember-data/store';
import type AbilitiesService from 'ember-can/services/abilities';
import type { PaginatedRecordArray } from 'garaje/infinity-models/v3-offset';
import type Flow from 'garaje/models/flow';
import type Location from 'garaje/models/location';
import type Questionnaire from 'garaje/models/questionnaire';

import type { VisitorTypesFlowRouteModel } from '../route';

interface FlowQuestionnairesRouteModel {
  flow: Flow;
  location: Location;
  questionnaireCount: number;
}

export default class FlowQuestionnairesRoute extends Route {
  @service declare abilities: AbilitiesService;
  @service declare router: RouterService;
  @service declare store: Store;

  beforeModel(): void {
    const { flow } = <VisitorTypesFlowRouteModel>this.modelFor('visitors.settings.visitor-types.flow');

    if (this.abilities.cannot('navigate questionnaires')) {
      this.router.replaceWith('visitors.settings.visitor-types.flow.index', flow.id);
    }
  }

  async model(): Promise<FlowQuestionnairesRouteModel> {
    const { currentLocation, flow } = <VisitorTypesFlowRouteModel>this.modelFor('visitors.settings.visitor-types.flow');

    const result = <PaginatedRecordArray<Questionnaire>>await this.store.query('questionnaire', {
      filter: {
        'include-global': true,
        location: currentLocation.id,
      },
      page: {
        limit: 1,
        offset: 0,
      },
    });
    const { meta } = <{ meta: { total: number } }>(result as unknown);

    return { flow, location: currentLocation, questionnaireCount: meta.total };
  }
}
